import { Feature, isFeatureEnabled } from '../../../../config/FeaturesConfig';
import { LighthouseDefaultName } from './displayTypes';

export const getMetricStringIdAndDefaultMessage = (
  metric: string
): {
  id: string;
  defaultMessage: string;
} => {
  const enableRAPRemovalAndCCXUpdate = isFeatureEnabled(
    Feature.ENABLE_RAP_REMOVAL_AND_CCX_UPDATE
  );
  const stringIdAndDefaultMessage = LighthouseDefaultName.get(
    enableRAPRemovalAndCCXUpdate && metric === 'CCX' ? 'CCX_V2' : metric
  );
  return {
    id: stringIdAndDefaultMessage?.[0] ?? '',
    defaultMessage: stringIdAndDefaultMessage?.[1] ?? '',
  };
};
